import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import api from "../api/axiosConfig";

export default function useActivityLogger(userId) {
  const location = useLocation();
  const lastTrackedRef = useRef("");

  useEffect(() => {
    if (!userId) return;
    const key = `${userId}:${location.pathname}`;
    if (lastTrackedRef.current === key) return;
    lastTrackedRef.current = key;

    const track = async () => {
      try {
        await api.post("/activity/track", {
          userId,
          path: location.pathname,
          timestamp: new Date().toISOString(),
        });
      } catch (err) {
        console.error("Activity logger error:", err?.message || err);
      }
    };

    track();
  }, [userId, location.pathname]);
}
